import { Suspense, lazy, useMemo } from "react";
import SeekerShell from "@/components/SeekerShell";

const PublicJobApply = lazy(() => import("@/pages/PublicJobApply"));

/**
 * Phase 153 — Keep the candidate portal header + footer around the public
 * apply page / thank-you page so logged-in seekers (and even anonymous
 * visitors) feel like they're still inside the portal, with a clear way
 * back to Browse jobs / Sign in.
 *
 * Skip the shell when this page is embedded in an iframe (recruiter embed
 * boards) — those are hosted on third-party sites and must not inherit
 * our chrome.
 */
export default function PublicJobApplyRoute() {
    const isEmbedded = useMemo(() => {
        if (typeof window === "undefined") return false;
        try {
            if (window.parent !== window) return true;
            const sp = new URLSearchParams(window.location.search);
            if (sp.get("embed")) return true;
        } catch {
            return true;  // cross-origin parent access throws; assume embedded
        }
        return false;
    }, []);

    const inner = (
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground font-mono">Loading…</div>}>
            <PublicJobApply />
        </Suspense>
    );

    if (isEmbedded) return inner;
    return <SeekerShell requireAuth={false}>{inner}</SeekerShell>;
}
